export default "__VITE_ASSET__CZuaw0pD__"